// SetPlay Build Version
// Major: Increment for major code/module deployments (e.g., 2.0 → 3.0)
// Minor: Increment for minor deployments/patches (e.g., 2.0 → 2.1)
export const BUILD_VERSION = "2.0";
